import { createSelector } from "reselect";

const payments = (state: any) => state.paymentsReducer;

export const getBankInfo = createSelector(payments, payments => payments.bankInfo);
